"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContrastText = void 0;
const tslib_1 = require("tslib");
const colors_1 = require("@mui/material/colors");
const styles_1 = require("@mui/material/styles");
const createPalette_1 = tslib_1.__importDefault(require("@mui/material/styles/createPalette"));
const colors_2 = require("./../colors");
const getContrastText = (color, contrastThreshold) => (0, styles_1.getContrastRatio)(color, "#FFFFFF") >= contrastThreshold ? "#FFFFFF" : "rgba(0, 0, 0, 0.87)";
exports.getContrastText = getContrastText;
/**
 * Some (legacy) places in argus the criticallity is defined as a number between 0 and 9.
 * These numbers are later mapped to different criticallity levels. The index of the array
 * indicate the mapping between a numeric severity and the corresponding criticallity enum.
 */
const criticalityIndex = [
    "low",
    "low",
    "low",
    "low",
    "medium",
    "high",
    "critical",
    "critical",
    "critical",
    "critical",
    "critical",
];
function createPalette(options = {}) {
    const { 
    /* Materials default is 3 */
    contrastThreshold = 3, mode, } = options;
    const isDarkMode = mode === "dark";
    const tertiary = isDarkMode
        ? [
            {
                light: "#7FD0F4",
                main: "#0072B2",
                dark: "#004362",
                contrastText: (0, exports.getContrastText)("#0072B2", contrastThreshold),
            },
            {
                light: "#F7C85F",
                main: "#F7C34F",
                dark: "#eeae1d",
                contrastText: (0, exports.getContrastText)("#F7C34F", contrastThreshold),
            },
            {
                light: "#A493BC",
                main: "#694B8F",
                dark: "#3c1b65",
                contrastText: (0, exports.getContrastText)("#694B8F", contrastThreshold),
            },
            {
                light: "#B8E4F8",
                main: "#56B4E9",
                dark: "#1d8dc5",
                contrastText: (0, exports.getContrastText)("#56B4E9", contrastThreshold),
            },
            {
                light: "#D89CBF",
                main: "#C46394",
                dark: "#772f55",
                contrastText: (0, exports.getContrastText)("#C46394", contrastThreshold),
            },
            {
                light: "#FFD187",
                main: "#F27718",
                dark: "#9b4405",
                contrastText: (0, exports.getContrastText)("#F27718", contrastThreshold),
            },
            {
                light: "#83D0B7",
                main: "#009E73",
                dark: "#004f3c",
                contrastText: (0, exports.getContrastText)("#009E73", contrastThreshold),
            },
            {
                light: "#82D9E9",
                main: "#25A4BC",
                dark: "#036577",
                contrastText: (0, exports.getContrastText)("#25A4BC", contrastThreshold),
            },
        ]
        : [
            // tertiary1
            {
                contrastText: (0, exports.getContrastText)(colors_2.tertiary1[500], contrastThreshold),
                dark: colors_2.tertiary1[500],
                light: colors_2.tertiary1[200],
                main: colors_2.tertiary1[300],
            },
            // tertiary2
            {
                contrastText: (0, exports.getContrastText)(colors_2.tertiary2[700], contrastThreshold),
                dark: colors_2.tertiary2[900],
                light: colors_2.tertiary2[400],
                main: colors_2.tertiary2[700],
            },
            // tertiary3
            {
                contrastText: (0, exports.getContrastText)(colors_2.tertiary3[700], contrastThreshold),
                dark: colors_2.tertiary3[900],
                light: colors_2.tertiary3[300],
                main: colors_2.tertiary3[700],
            },
            // tertiary4
            {
                contrastText: (0, exports.getContrastText)(colors_2.tertiary4[100], contrastThreshold),
                dark: colors_2.tertiary4[200],
                light: colors_2.tertiary4[50],
                main: colors_2.tertiary4[100],
            },
            // tertiary5
            {
                contrastText: (0, exports.getContrastText)(colors_2.tertiary5[500], contrastThreshold),
                dark: colors_2.tertiary5[800],
                light: colors_2.tertiary5[300],
                main: colors_2.tertiary5[500],
            },
            // tertiary6
            {
                contrastText: (0, exports.getContrastText)(colors_2.tertiary6[800], contrastThreshold),
                dark: colors_2.tertiary6[900],
                light: colors_2.tertiary6[500],
                main: colors_2.tertiary6[800],
            },
            // tertiary7
            {
                contrastText: (0, exports.getContrastText)(colors_2.tertiary7[200], contrastThreshold),
                dark: colors_2.tertiary7[300],
                light: colors_2.tertiary7[100],
                main: colors_2.tertiary7[200],
            },
            // tertiary8
            {
                contrastText: (0, exports.getContrastText)(colors_2.tertiary8[400], contrastThreshold),
                dark: colors_2.tertiary8[600],
                light: colors_2.tertiary8[200],
                main: colors_2.tertiary8[400],
            },
        ];
    const criticality = isDarkMode
        ? {
            critical: {
                contrastText: (0, exports.getContrastText)("#DA8079", contrastThreshold),
                dark: "#D75440",
                light: "#E6A29E",
                main: "#E26758",
            },
            high: {
                contrastText: (0, exports.getContrastText)("#F6EF95", contrastThreshold),
                dark: "#EDE022",
                light: "#FAF6BF",
                main: "#F2E96B",
            },
            medium: {
                contrastText: (0, exports.getContrastText)("#80C397", contrastThreshold),
                dark: "#4DAA6E",
                light: "#C7E4D1",
                main: "#80C397",
            },
            low: {
                contrastText: (0, exports.getContrastText)("#6FC0E5", contrastThreshold),
                dark: "#54A6DA",
                light: "#B9E4F5",
                main: "#6FC0E5",
            },
        }
        : {
            critical: {
                contrastText: (0, exports.getContrastText)(colors_2.red[500], contrastThreshold),
                dark: colors_2.red[700],
                light: colors_2.red[200],
                main: colors_2.red[500],
            },
            high: {
                contrastText: (0, exports.getContrastText)(colors_2.amber[400], contrastThreshold),
                dark: colors_2.amber[700],
                light: colors_2.amber[200],
                main: colors_2.amber[400],
            },
            low: {
                contrastText: (0, exports.getContrastText)(colors_2.blue[700], contrastThreshold),
                dark: colors_2.blue[900],
                light: colors_2.blue[200],
                main: colors_2.blue[700],
            },
            medium: {
                contrastText: (0, exports.getContrastText)(colors_2.green[500], contrastThreshold),
                dark: colors_2.green[800],
                light: colors_2.green[200],
                main: colors_2.green[500],
            },
        };
    /**
     * All main, light and dark colors are the same.
     * The downside of this is is that these colors *cannot* be used on
     * interactive elements. Eg Buttons. Effects like hover and ripple need
     * dark and light colors.
     */
    const sampleVerdictColor = {
        malicious: {
            contrastText: (0, exports.getContrastText)(colors_2.red[700], contrastThreshold),
            dark: colors_2.red[700],
            light: colors_2.red[700],
            main: colors_2.red[700],
        },
        unwanted: {
            contrastText: (0, exports.getContrastText)(colors_2.orange[800], contrastThreshold),
            dark: colors_2.orange[800],
            light: colors_2.orange[800],
            main: colors_2.orange[800],
        },
        suspicious: {
            contrastText: (0, exports.getContrastText)(colors_2.orange[500], contrastThreshold),
            dark: colors_2.orange[500],
            light: colors_2.orange[500],
            main: colors_2.orange[500],
        },
        unknown: {
            contrastText: (0, exports.getContrastText)(colors_1.grey[700], contrastThreshold),
            dark: colors_1.grey[700],
            light: colors_1.grey[700],
            main: colors_1.grey[700],
        },
        benign: {
            contrastText: (0, exports.getContrastText)(colors_2.green[800], contrastThreshold),
            dark: colors_2.green[800],
            light: colors_2.green[800],
            main: colors_2.green[800],
        },
        noFindings: {
            contrastText: (0, exports.getContrastText)(colors_2.green[800], contrastThreshold),
            dark: colors_2.green[800],
            light: colors_2.green[800],
            main: colors_2.green[800],
        },
    };
    const getTertiaryColor = (index) => {
        if (index >= tertiary.length) {
            // tslint:disable-next-line:no-console
            console.error(`@mnemonic/mui5: You asked for a tertiaryColor index which does not exists. You as for index ${index} we only have ${tertiary.length} tertiary colors`);
        }
        return tertiary[index];
    };
    const getVerdictColor = (key) => {
        if (!Object.keys(sampleVerdictColor).some((x) => x === key)) {
            console.error(`@mnemonic/mui5: You asked for a verdict color which does not exists. You asked for index ${key}.`);
            // Fallback to unknown
            return sampleVerdictColor["unknown"];
        }
        return sampleVerdictColor[key];
    };
    const getCriticalityColor = (crit) => {
        if (typeof crit === "number") {
            if (crit >= criticalityIndex.length) {
                // tslint:disable-next-line:no-console
                console.error(`@mnemonic/mui5: You asked for a criticality index which does not exists. You as for index ${crit} we only have ${criticalityIndex.length} criticality indexes`);
            }
            return criticality[criticalityIndex[crit]];
        }
        return criticality[crit.toLowerCase()];
    };
    const error = criticality.critical;
    const warning = isDarkMode
        ? {
            contrastText: (0, exports.getContrastText)("#FFA422", contrastThreshold),
            light: "#FFCA7E",
            main: "#FFA422",
            dark: "#FF8800",
        }
        : criticality.high;
    const info = criticality.low;
    const success = criticality.medium;
    return (0, createPalette_1.default)({
        criticality,
        getCriticalityColor,
        getTertiaryColor,
        getVerdictColor,
        tertiary,
        error,
        warning,
        info,
        success,
        background: {
            default: isDarkMode ? "#121212" : colors_2.black[100],
            paper: isDarkMode ? "#121212" : "#fff",
        },
        grey: colors_2.black,
        ...options,
    });
}
exports.default = createPalette;
